import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site-data';

const footerLinks = [
  {
    title: '内容导航',
    links: [
      { label: '定义与用途', path: '/category/dingyi-yongtu' },
      { label: '获取方式', path: '/category/huoqu-fangshi' },
      { label: '注意事项', path: '/category/zhuyi-shixiang' },
      { label: '常见问题', path: '/category/changjian-wenti' },
      { label: '法律政策', path: '/category/falv-zhengce' },
      { label: '使用技巧', path: '/category/shiyong-jiqiao' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系方式', path: '/about#contact' },
      { label: '用户反馈', path: '/about#feedback' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="lg:col-span-1">
              <Link
                to="/"
                className="font-heading text-xl font-bold text-background-50 hover:text-primary-300 transition-colors"
              >
                黄本子指南
              </Link>
              <p className="mt-3 text-sm text-background-300 leading-relaxed">
                {siteInfo.tagline}
              </p>
              <p className="mt-3 text-sm text-background-400">
                {siteInfo.description}
              </p>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-semibold text-background-100 mb-4">
                  {group.title}
                </h4>
                <ul className="flex flex-col gap-2.5">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-sm text-background-400 hover:text-primary-300 transition-colors"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">
                联系我们
              </h4>
              <ul className="flex flex-col gap-2.5 text-sm text-background-400">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line text-base"></i>
                  <span>{siteInfo.email}</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-phone-line text-base"></i>
                  <span>{siteInfo.phone}</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-map-pin-line text-base"></i>
                  <span>{siteInfo.address}</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; {new Date().getFullYear()} {siteInfo.name}. 保留所有权利。
            </p>
            <p className="text-sm text-background-500">
              本站内容仅供参考，具体以官方发布为准
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}